// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edm-aami-wrapper {
  height: 100vh;
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  -webkit-font-smoothing: antialiased !important;
  background-color: #f7f7f7 !important; }
  .edm-aami-wrapper img {
    border: 0 !important;
    outline: none !important; }
  .edm-aami-wrapper p {
    margin: 0px !important;
    padding: 0px !important; }
  .edm-aami-wrapper table {
    border-collapse: collapse;
    mso-table-lspace: 0px;
    mso-table-rspace: 0px;
    background-color: #ffffff !important; }
  .edm-aami-wrapper td,
  .edm-aami-wrapper a,
  .edm-aami-wrapper span {
    border-collapse: collapse;
    mso-line-height-rule: exactly; }
  .edm-aami-wrapper a[x-apple-data-detectors] {
    color: inherit !important;
    text-decoration: none !important;
    font-size: inherit !important;
    font-family: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important; }
  .edm-aami-wrapper .ExternalClass * {
    line-height: 100%; }
  .edm-aami-wrapper .em_defaultlink a {
    color: inherit !important;
    text-decoration: none !important; }
  .edm-aami-wrapper .em_g_img + div {
    display: none; }

@media only screen and (max-width: 640px) {
  .edm-aami-wrapper .em_img {
    width: 100% !important;
    height: auto !important; }
  .edm-aami-wrapper .em_main_table {
    width: 100% !important; }
  .edm-aami-wrapper .em_wrapper {
    width: 100% !important; }
  .edm-aami-wrapper .em_wrapper1 {
    width: 100% !important;
    display: block !important; }
  .edm-aami-wrapper .em_height {
    height: auto !important; }
  .edm-aami-wrapper .em_hide {
    display: none !important; }
  .edm-aami-wrapper .em_padding20 {
    padding-top: 20px !important; }
  .edm-aami-wrapper .em_padding {
    padding-left: 10px !important;
    padding-right: 10px !important; }
  .edm-aami-wrapper .em_font22 {
    font-size: 22px !important;
    line-height: 28px !important; }
  .edm-aami-wrapper .em_font {
    font-size: 10px !important;
    line-height: 14px !important; }
  .edm-aami-wrapper u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important; } }
`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/edm/aami/EdmAami.scss"],"names":[],"mappings":"AAAA;EACC,aAAa;EACb,SAAS;EACT,UAAU;EACV,yCAAyC;EACzC,qCAAqC;EACrC,8CAA8C;EAC9C,oCAAoC,EAAA;EAPrC;IAUE,oBAAoB;IACpB,wBAAwB,EAAA;EAX1B;IAcE,sBAAsB;IACtB,uBAAuB,EAAA;EAfzB;IAkBE,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,oCAAoC,EAAA;EArBtC;;;IA0BE,yBAAyB;IACzB,6BAA6B,EAAA;EA3B/B;IA8BE,yBAAyB;IACzB,gCAAgC;IAChC,6BAA6B;IAC7B,+BAA+B;IAC/B,+BAA+B;IAC/B,+BAA+B,EAAA;EAnCjC;IAuCE,iBAAiB,EAAA;EAvCnB;IA0CE,yBAAyB;IACzB,gCAAgC,EAAA;EA3ClC;IA8CE,aAAa,EAAA;;AAId;EACC;IACW,sBAAsB;IAAE,uBAAuB,EAAA;EAD1D;IAEiB,sBAAsB,EAAA;EAFvC;IAGc,sBAAsB,EAAA;EAHpC;IAIe,sBAAsB;IAAE,yBAAyB,EAAA;EAJhE;IAKa,uBAAsB,EAAA;EALnC;IAMW,wBAAwB,EAAA;EANnC;IAOgB,4BAA4B,EAAA;EAP5C;IAQc,6BAA6B;IAAE,8BAA8B,EAAA;EAR3E;IASa,0BAA0B;IAAE,4BAA4B,EAAA;EATrE;IAUW,0BAA0B;IAAE,4BAA4B,EAAA;EAVnE;IAW8B,sBAAsB;IAAE,uBAAuB,EAAA,EAAG","sourcesContent":[".edm-aami-wrapper {\n\theight: 100vh;\n\tmargin: 0;\n\tpadding: 0;\n\t-webkit-text-size-adjust: 100% !important;\n\t-ms-text-size-adjust: 100% !important;\n\t-webkit-font-smoothing: antialiased !important;\n\tbackground-color: #f7f7f7 !important;\n\n\timg {\n\t\tborder: 0 !important;\n\t\toutline: none !important;\n\t}\n\tp {\n\t\tmargin: 0px !important;\n\t\tpadding: 0px !important;\n\t}\n\ttable {\n\t\tborder-collapse: collapse;\n\t\tmso-table-lspace: 0px;\n\t\tmso-table-rspace: 0px;\n\t\tbackground-color: #ffffff !important;\n\t}\n\ttd,\n\ta,\n\tspan {\n\t\tborder-collapse: collapse;\n\t\tmso-line-height-rule: exactly;\n\t}\n\ta[x-apple-data-detectors] {\n\t\tcolor: inherit !important;\n\t\ttext-decoration: none !important;\n\t\tfont-size: inherit !important;\n\t\tfont-family: inherit !important;\n\t\tfont-weight: inherit !important;\n\t\tline-height: inherit !important;\n\t}\n\n\t.ExternalClass * {\n\t\tline-height: 100%;\n\t}\n\t.em_defaultlink a {\n\t\tcolor: inherit !important;\n\t\ttext-decoration: none !important;\n\t}\n\t.em_g_img + div {\n\t\tdisplay: none;\n\t}\n}\n\n\t@media only screen and (max-width: 640px){\n\t\t.edm-aami-wrapper {\n\t\t\t.em_img { width: 100% !important; height: auto !important; }\n\t\t\t.em_main_table {width: 100% !important;}\n\t\t\t.em_wrapper {width: 100% !important;}\n\t\t\t.em_wrapper1 {width: 100% !important; display: block !important;}\n\t\t\t.em_height {height:auto !important;}\n\t\t\t.em_hide {display: none !important;\t}\n\t\t\t.em_padding20 {padding-top: 20px !important;}\n\t\t\t.em_padding {padding-left: 10px !important; padding-right: 10px !important;\t}\n\t\t\t.em_font22 {font-size: 22px !important; line-height: 28px !important;\t}\n\t\t\t.em_font {font-size: 10px !important; line-height: 14px !important;\t}\n\t\t\tu + .em_body .em_full_wrap { width: 100% !important; width: 100vw !important;}\n\t\t}\n\t}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
